import { Grid, Typography } from "@mui/material";
import { FormSection } from "components/FormControls/FormSection";
import { useStyles } from "components/Layout/Campaign/Common/Campaign.styles";
import { useMessage } from "hooks/intl";
import { memo } from "react";
import { CampaignLimits as CampaignLimitsType } from "types/campaigns";
import { Limit } from "./Limit";

interface Props {
  limits: Partial<CampaignLimitsType>;
}

export const AutomationLimits = memo(({ limits }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <FormSection title={message({ id: "setAutomationLimitsAndBudget" })}>
      <Grid container spacing={12}>
        <Grid item xs={12}>
          <Typography className={classes.limitTitle}>
            {message({ id: "automationLimit" })}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Limit
            name="executionsPerMember"
            data-test-id="campaign-limits-executions-per-member"
            value={limits.executionsPerMember}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.limitTitle}>
            {message({ id: "automationBudget" })}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Limit
            name="points"
            value={limits.points}
            data-test-id="campaign-limits-points"
          />
        </Grid>
        <Grid item xs={12}>
          <Limit
            name="pointsPerMember"
            value={limits.pointsPerMember}
            data-test-id="campaign-limits-points-per-member"
          />
        </Grid>
      </Grid>
    </FormSection>
  );
});
